var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2309 20.7195C29.2913 26.6215 34.9374 28.5855 35 28.6105C34.9523 28.7489 34.0978 31.4093 32.0254 34.1573C30.2337 36.5332 28.3744 38.9002 25.4452 38.9492C22.5671 38.9974 21.6416 37.4007 18.351 37.4007C15.0615 37.4007 14.0332 38.9003 11.3087 38.9974C8.48135 39.0946 6.32828 36.4284 4.52189 34.0612C0.830606 29.2193 -1.9903 20.379 1.79746 14.4117C3.67914 11.4483 7.04185 9.57174 10.6918 9.52362C13.4682 9.47557 16.0887 11.2183 17.786 11.2183C19.4822 11.2183 22.6667 9.1225 26.0145 9.43031C27.416 9.48323 31.3502 9.94396 33.8763 13.2989C33.6727 13.4134 29.1821 15.7852 29.2309 20.7195ZM23.8218 6.22694C25.3228 4.57838 26.3331 2.28345 26.0575 0C23.8938 0.0789004 21.2775 1.30816 19.7255 2.95581C18.3347 4.41487 17.1166 6.7502 17.4453 8.98845C19.8569 9.15774 22.3206 7.87653 23.8218 6.22694Z",
    fill: "#100F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacOs);
export default __webpack_public_path__ + "static/media/mac_os.f4da5a9793f1b7a8833319eefc913faf.svg";
export { ForwardRef as ReactComponent };